import Vue from 'vue';
import layoutBase from '../layout-base.js';
import { PubsubReplay } from 'pubsub-replay';
import SidebarItem from '../../frame-vue/header/sidebar-item/sidebar-item';
import SidebarSubItem from '../../frame-vue/header/sidebar-sub-item/sidebar-sub-item';
import Notification from '../../common/components/notification/notification';
import RelatedProperties from '../../application-vue/real-estate-data/related-properties';
import RealEstateCarousel from '../../application-vue/real-estate-data/real-estate-carousel';
import RealEstateMap from '../../application-vue/real-estate-data/real-estate-map';
import RealEstateData from '../../application-vue/real-estate-data/real-estate-data';
import store from '../../common/js/store/store';
import realEstateDataModule from '../../application-vue/real-estate-data/real-estate-data-vuex';
import * as VueGoogleMaps from 'vue2-google-maps';
import Vuelidate from 'vuelidate';
store.registerModule('real-estate-data', realEstateDataModule);
Vue.component('sidebar-item', SidebarItem);
Vue.component('sidebar-sub-item', SidebarSubItem);
Vue.use(VueGoogleMaps, {
	load: {
		key: window.MAP_KEY
	}
});
Vue.use(Vuelidate);
if (!window.ipEventBus) {
	window.ipEventBus = PubsubReplay;
}
new Vue({
	extends: layoutBase,
	el: '[data-layout-id=AADAT-app]',
	data: () => ({
		rightColumnVisible: false,
		notification: null
	}),
	components: {
		Notification,
		RelatedProperties,
		RealEstateCarousel,
		RealEstateData,
		RealEstateMap
	},
	mounted() {
		window.ipEventBus.publish('initAngularApp', true);
	}
});
